import { uniqueIdFactory } from './normalize/uniqueIds';
import { QuizzesItem } from './types';

interface PathForItemByIdParams {
  uniqueId: string;
  allItems: Record<string, QuizzesItem>;
}

export function getPathForItemById({
  uniqueId,
  allItems,
}: PathForItemByIdParams) {
  if (!allItems) throw new Error('Must provide an object with all the items');
  if (!Object.keys(allItems).includes(uniqueId)) {
    throw new Error('Unique ID does not exist in collection');
  }

  let paths = [];
  let item = allItems[uniqueId];
  const seenItems = new Set();
  while (itemHasParent(item)) {
    if (seenItems.has(item.uniqueId))
      throw new Error('Invalid path, contains circular references');
    seenItems.add(item.uniqueId);
    const parent = getItemParent(item, allItems);
    paths = [parent.uniqueId, ...paths];
    item = parent;
  }

  return paths;
}

const getItemParent = (
  quizzesItem: QuizzesItem,
  allItems: Record<string, QuizzesItem>
) => allItems[uniqueIdFactory['folder'].toUniqueId(quizzesItem.parentId)];

const itemHasParent = (quizzesItem: QuizzesItem) =>
  quizzesItem.parentId !== null;
